import { Fragment } from "react";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import { getLocale } from "./locale-selectors";
import { getTranslation } from "../brand/brand-selectors";

function mapStateToProps(state) {
  const locale = getLocale(state);
  const translation = getTranslation(state);
  let localeSettings;
  if (translation[locale]) {
    localeSettings = translation[locale];
  } else {
    throw new Error(`No translation for locale "${locale}"`);
  }

  // NOTE that React.Fragment is set as textComponent to avoid rendering <span> when using FormattedMessage from react-intl
  // By using React.Fragment we can use FormattedMessage also in places where rendered <span> would cause isses, e.g. inside <option>
  return {
    locale: locale,
    key: locale,
    messages: localeSettings.messages,
    textComponent: Fragment
  };
}

export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./src/modules/i18n/redux-intl-provider.js